var routes = [
  {
    path: '/participant-card-builder',
    name: 'participant-cards',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: function () { return import('./Index.vue') }
  },
  {
    path: '/participant-card-builder/:id',
    name: 'participant-card-builder',
    meta: {
      authRequired: true,
      roles: ['Admin']
    },
    component: function () { return import('./Builder.vue') }
  }
]

export { routes }
export default routes
